(function Module() {
	'use strict';

	module.exports = {
		cookie: require('./cookie'),
		message: require('./message'),
		applicationInsights: require('./application-insights')
	};
})();
